export interface IHasSubscriptionArgs {
	user: { abbonamenti: ReadonlyArray<unknown> } | null;
}

export const hasSubscription = (visArgs: IHasSubscriptionArgs): boolean => {
	const { user } = visArgs;
	if (user?.abbonamenti && user?.abbonamenti?.length > 0) return true;
	return false;
};
